export const PROTECTED_DOMAINS = [
  "innovami.com",
  "innovamarketinsights360.com",
  "packaginginsights.com",
  "resource-innova.s3.amazonaws.com",
  "cnsmedia.com",
  "foodingredientsfirst.com",
  "nutritioninsight.com",
  "personalcareinsights.com",
  "theworldoffoodingredients.html",
];

export const STRUCTURAL_FINGERPRINTS = [
  "fb:app_id",
  "video_id",
  "magazine.packaginginsights.com/previewvideo",
  "CNS MEDIA",
  "technical@innovami.com",
];

// New template uses neurofys.org as the primary image host
export const IMAGE_HOSTS = [
  "https://neurofys.org/images",
  "https://nubupaths.online/images",
];

export const VIDEO_HOST = "https://lanetacampeche.com/video";

// ── Original template anchors (New Parasite Template 1 — Mitolyn baseline) ──
export const ORIG_KEYWORD_LINE = "Mitolyn Reviews 2026";
export const ORIG_PRODUCT = "Mitolyn";

// Subtitle as it appears in the new template (single and double paren variants)
export const ORIG_SUBTITLE_SINGLE =
  "(The Results That Caught Everyone Off Guard)";
export const ORIG_SUBTITLE_DOUBLE =
  "((The Results That Caught Everyone Off Guard))";

// Trailing phrase as it appears in the new template (intentional typo preserved)
export const ORIG_TRAILING = "Where to buy, Price , Beneftis";

// Card video .mp4 hrefs from the new template
export const ORIG_CARD1_HREF_MP4 =
  "https://lanetacampeche.com/video/F0JH8RXB0KMT2FHPEZR1M3.mp4";
export const ORIG_CARD2_HREF_MP4 =
  "https://lanetacampeche.com/video/1EGRXD0X37RSYZZQIH4B4O.mp4";

// Primary image URL from the new template (og:image in <head>)
export const ORIG_IMAGE_URL =
  "https://neurofys.org/images/6CT9PCYKRK3554Q/9633170429097727.jpg";

// Canonical URL from the new template (og:url / siteroot)
export const ORIG_CANONICAL_URL =
  "https://lanetacampeche.com/video/drinktec-2025-sidel-debuts-laser-blowing.html";

// The default hosting base used in this template — replaced by canonicalPatcher
// when the user supplies a custom Canonical Base URL.
export const DEFAULT_HOSTING_BASE = "https://lanetacampeche.com/video/";

// Bracket tokens found in the new template
export const ORIG_TOKENS = [
  "[CNAFMX1H]",
  "[RO86QGQ3]",
  "[FZP7OE9W]",
  "[6RJOUY7X]",
  "[FFPYGRLN]",
  "[NSREM1UJ]",
  "[7II1NTES]",
  "[AO4BEWSF]",
];

// ── Old subtitle texts to sweep out of any residual template occurrences ──
export const ORIG_SUBTITLE_TEXTS = [
  "(The Results That Caught Everyone Off Guard)",
  "((The Results That Caught Everyone Off Guard))",
  "The Results That Caught Everyone Off Guard",
  // Keep old baseline subtitles for cross-template safety
  "(The Eye-Opening Moment That Led to *Unbelievable* Success)",
  "((The Eye-Opening Moment That Led to *Unbelievable* Success))",
  "The Eye-Opening Moment That Led to *Unbelievable* Success",
];

// ── Old product name variants to sweep ──
export const ORIG_PRODUCT_VARIANTS = [
  "Mitolyn",
  "mitolyn",
  "MITOLYN",
  // Keep old baseline variants for cross-template safety
  "Fit Burn",
  "Fitburn",
  "fit burn",
  "fitburn",
  "FIT BURN",
];